module.exports = __webpack_public_path__ + "img/hero-3m.5f63311.jpg";